import CargoCompanyAddressAddRequest, {
  CargoCompanyAddressAddRequestBody,
} from "./cargo-company-address-add.request";

const createBody = (
  request: CargoCompanyAddressAddRequest,
): CargoCompanyAddressAddRequestBody => {
  return {
    apartment: request.apartment,
    country: request.country,
    description: request.description,
    houseNo: request.houseNo,
    lat: request.lat,
    lon: request.lon,
    street: request.street,
    town: request.town,
    type: request.type,
    zipCode: request.zipCode,
  };
};

const cargoCompanyAddressAddRequestFactory = {
  createBody,
};

export default cargoCompanyAddressAddRequestFactory;
